import helpers from "../helpers/common";
import request from "../helpers/request";

const paysystems = {}

paysystems.getData = async () => {
    return request.get('/paysystems', {}, true)
}

export default paysystems